import { api } from "@/lib/api";

const KEY = "cb_session_id";

export function getSessionId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = "sess_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(KEY, id);
  }
  return id;
}

export function track(type, props = {}) {
  try {
    api.post("/track", {
      type,
      session_id: getSessionId(),
      path: window.location.pathname,
      ...props,
    }).catch(() => {});
  } catch {
    /* never block UX on analytics */
  }
}
